<template>
	<div>
		<div v-if="loading"><loading type="page" /></div>
		<div v-else-if="!active" class="inactive-page">
			<p>TASKBANK FOR THIS TENANT IS NOT ACTIVE.</p>
		</div>
		<div v-else id="content" class="app-content box-shadow-3">
			<div class="topbar">
				<div class="navbar theme-login bg box-shadow">
					<div>
						<a :href="`#/public/tasks/${refID}`" class="navbar-brand oscar-logo">
							<img :src="brand.logoHeader" alt="." class />
						</a>
					</div>
					<div v-if="!bankUser" class>
						<div class="btn btn-outline-light" v-on:click="goToLogin()">Login</div>
						<div class="btn btn-outline-light" v-on:click="goToRegister()">Create Account</div>
					</div>
					<div v-if="bankUser" class>
						Welcome Back {{ bankUser.name }}
						<div class="btn btn-outline-light m-3" v-on:click="goToProfile()">Profile</div>

						<div class="btn btn-outline-light m-3" v-on:click="Logout()">Logout</div>
					</div>
				</div>
				<section class="theme-login-light jumbotron text-center">
					<div class="container">
						<h1 class="jumbotron-heading">{{ taskbank.header_text }}</h1>
						<p v-html="taskbank.description" class="lead text-muted"></p>
					</div>
				</section>
			</div>
			<div class="main-content" id="facture">
				<div class="container">
					<div class="row">
						<div class="col-md-3 left-section panel-panel content-left">
							<h2 class="pane-title theme-login-text">FILTERS</h2>
							<div class="content theme-login-text">
								<div class="form-group">
									<label>{{ taskbank.field_names.content_area }}s :</label>
									<v-select
										multiple
										placeholder="Any"
										:options="contentAreas"
										v-model="selectedContentAreas"
										label="name"
										class="overflow-fix"
									></v-select>
								</div>
								<!-- <div class="form-group">
                <label>Essential Skill :</label>
                <config-select
                  :nullOption="true"
                  :options="essentialSkills"
                  v-model="selectedEssentialSkill"
                  nullText="Any"
                ></config-select>
                </div>-->
								<div class="form-group">
									<label>Grade :</label>
									<v-select
										sortBy="sequence"
										multiple
										placeholder="Any"
										:options="grades"
										v-model="selectedGrades"
										label="name"
										class="overflow-fix"
									></v-select>
								</div>
								<div class="form-group">
									<label>{{ taskbank.field_names.standard }} :</label>
									<v-select
										sortBy="sequence"
										multiple
										placeholder="Any"
										:options="standards"
										v-model="selectedStandards"
										label="name"
										class="overflow-fix"
									></v-select>
								</div>
								<div class="form-group">
									<label>{{ taskbank.field_names.district }}s :</label>
									<v-select
										sortBy="sequence"
										multiple
										placeholder="Any"
										:options="districts"
										v-model="selectedDistricts"
										label="name"
										class="overflow-fix"
									></v-select>
								</div>
							</div>
						</div>
						<div class="col-md-9 right-section panel-panel content-right">
							<div class="row">
								<div class="col-md-6">
									<h2 class="pane-title theme-login-text">Tasks</h2>
								</div>
								<div class="col-md-6">
									<input type="text" v-model="filter" class="form-control" placeholder="Search..." />
								</div>
							</div>

							<hr />
							<div v-if="this.asmtLength == 0" class="row">
								<loading v-if="loadingAssessments" type="page" />
								<div v-else class="col-xs-12 center-block text-center text-danger">
									<h2>No Assessments Found</h2>
								</div>
							</div>
							<div class="row">
								<div v-for="asmt in selectedAssessments" v-bind:key="asmt.id" class="col-md-5 box">
									<div class="inner" :id="asmt.id">
										<div class="col-md-4">
											<!-- <div class="btn btn-lg loadMore" >Download</div> -->
										</div>
										<public-assessment-row
											:contentAreas="contentAreas"
											:assessment="asmt"
											:fieldNames="taskbank.field_names"
										></public-assessment-row>
									</div>
								</div>
							</div>
							<div v-if="loaded < this.asmtLength" class="row justify-content-md-center">
								<div class="col-md-4" @click="loadMore()">
									<div class="btn btn-lg loadMore">Load More</div>
								</div>
							</div>
						</div>
						<div class="col-md-9">
							<br />
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="active" class="theme-login p-3 b-t mt-auto theme" v-html="taskbank.copyright"></div>
	</div>
</template>

<style scoped>
.margin-overlap {
	margin-right: -2.5rem;
}

.jumbotron {
	color: white;
	border-radius: 0px;
}
.left-section {
	background: #f4f3ef;
	padding: 1rem;
	border: 1px solid #ccc;
}
.right-section {
	padding-left: 50px;
}
.taskLabel {
	display: inline-block;
	font-size: 0.875rem;
	font-family: "source_sans_prosemibold", Helvetica, Arial, sans-serif;
	color: #5f574f;
	text-transform: uppercase;
	margin: auto;
}
.mainContainer {
	border: 1px solid #ccc;
	padding: 10px;
}

.box {
	border: 1px solid #ccc;

	padding: 5px;
	margin-left: 10px;
}
.inner {
	background-color: #fff;
}
.loadMore {
	border-radius: 3px;
	font-family: "source_sans_prosemibold", Helvetica, Arial, sans-serif;
	display: inline-block;
	width: 100%;
	height: 3.125rem;
	margin: 0;
	padding: 0.5625rem 0.625rem;
	vertical-align: middle;
	background-color: #f3f3ee;
	color: #5f574f;
	font-size: 1rem;
	line-height: 2.125rem;
	letter-spacing: 0.0625rem;
	text-align: center;
	text-transform: uppercase;
	text-decoration: none;
}

div.inactive-page {
	padding-top: 500px;
	height: 10em;
	position: relative;
}
div.inactive-page p {
	margin: 0;
	position: absolute;
	font-size: 3rem;
	top: 50%;
	left: 50%;
	margin-right: -50%;
	transform: translate(-50%, -50%);
}
</style>

<script async src="https://www.googletagmanager.com/gtag/js?id=G-2DK9DFNQYD"></script>
<script>
window.dataLayer = window.dataLayer || [];
function gtag() {
	dataLayer.push(arguments);
}
gtag("js", new Date());

gtag("config", "G-2DK9DFNQYD");
</script>

<script>
import EditPane from "@/components/EditPane";
import SaveOptionalModal from "@/components/SaveOptionalModal";
import ConfigSelect from "@/components/ConfigSelect";
import RichText from "@/components/RichText";
import PublicAssessmentRow from "@/components/assessment/PublicAssessmentRow";

import AssessmentService from "@/services/AssessmentService";
import ConfigService from "@/services/ConfigService";
import GradeService from "@/services/GradeService";
import DistrictService from "@/services/DistrictService";
import TaskBankService from "@/services/TaskBankService";
import Router from "@/router";

import store from "@/services/Store";

import ValidationService from "@/services/ValidationService";
import Notie from "@/services/NotieService";
import fs from "@/services/FormatService";
import BB from "bluebird";
import Utils from "@/services/Utils";
import draggable from "vuedraggable";
import ConfigItemSearch from "@/components/ConfigItemSearch";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import moment from "moment";
import BrandService from "@/services/BrandService";
var brand = BrandService.getBrand();

export default {
	name: "PublicAssessments",

	props: ["id", "defaultTab", "valid"],

	components: {
		EditPane,
		SaveOptionalModal,
		ConfigSelect,
		ConfigItemSearch,
		RichText,
		draggable,
		PublicAssessmentRow,
	},

	data() {
		return {
			fs: fs,
			brand: brand,
			ntests: 0,
			originalDesc: [],
			refresh: null,
			assessment: {},
			dirty: false,
			saveOptModal: false,
			saveOptNext: () => {},
			saveOptCancel: () => {},
			assessments: [],
			districts: [],
			selectedAssessments: [],
			filteredAssessments: [],
			refID: this.$route.params.tenantID,
			standards: [],
			grades: [],
			essentialSkills: [],
			contentAreas: [],
			selectedStandards: [],
			selectedGrades: [],
			selectedContentAreas: [],
			selectedEssentialSkill: null,
			selectedDistricts: [],
			loaded: 0,
			searchObject: null,
			asmtLength: 0,
			standards_text: "Standards",
			taskbank: null,
			active: false,
			loading: true,
			loadingAssessments: true,
			filter: "",
			bankUser: null,
		};
	},

	computed: {},
	mounted() {
		// if (this.refID == "CCE") {
		//   window.dataLayer = window.dataLayer || [];
		//   function gtag() {
		//     dataLayer.push(arguments);
		//   }
		//   gtag("js", new Date());
		//   console.log("Script Added");
		//   gtag("config", "G-2DK9DFNQYD");
		// }
	},
	created() {
		this.assessment = {
			name: "this is then ame",
			ref_id: "test",
			description: "test description",
			grades: [{ id: "grade1" }],
			standards: ["st1", "st2"],
		};

		this.checkUser();
		this.searchObject = {
			standards: [],
			contentAreas: [],
			grades: [],
			districts: [],
		};
		if (this.refID == "CCE") {
			this.standards_text = "Massachusetts Standards";
		}
		this.loadTaskBankConfiguration();
	},

	watch: {
		selectedGrades(newVal) {
			this.searchObject.grades = newVal;
			this.filterAssesments();
			store.set(this, "public.grades", this.searchObject.grades);

			console.log(" changed search object : ", this.searchObject.grade);
		},
		selectedStandards(newVal) {
			this.searchObject.standards = newVal;
			this.filterAssesments();
			store.set(this, "public.standards", this.searchObject.standards);

			console.log(" changed search object : ", this.searchObject.standard);
		},
		selectedContentAreas(newVal) {
			this.searchObject.contentAreas = newVal;
			this.filterAssesments();
			store.set(this, "public.contentAreas", this.searchObject.contentAreas);

			console.log(" changed search object : ", this.searchObject.contentAreas);
		},
		selectedDistricts(newVal) {
			this.searchObject.districts = newVal;
			this.filterAssesments();
			store.set(this, "public.districts", this.searchObject.districts);

			console.log(" changed search object : ", this.searchObject.districts);
		},
		filter(newVal) {
			console.log(newVal);
			this.filterAssesments();
			let filtered = this.selectedAssessments.filter(function (asmt) {
				return asmt.name.toLowerCase().includes(newVal) || asmt.description.toLowerCase().includes(newVal);
			});
			this.selectedAssessments = filtered;
		},
	},

	beforeRouteLeave(to, from, next) {
		if (this.dirty) {
			this.saveOptNext = () => {
				next();
			};
			this.saveOptCancel = () => {
				next(false);
			};
			this.saveOptModal = true;
		} else {
			next();
		}
	},

	methods: {
		loadData() {
			AssessmentService.listPublicAssessments(this.refID)
				.then((resp) => {
					this.loadingAssessments = false;
					this.assessments = resp.data.assessments;
					this.loadMore();
					this.asmtLength = this.assessments.length;
					this.filteredAssessments = this.selectedAssessments;
				})
				.catch((err) => {
					this.loadingAssessments = false;
					console.log(err);
					Notie.error("Failed to load public assessment", err);
				});
		},

		loadTaskBankConfiguration() {
			TaskBankService.getPublicTaskBank(this.refID)
				.then((resp) => {
					this.loading = false;
					this.taskbank = resp.data;
					this.active = resp.data.active;
					this.loadData();
					this.loadConfigData();
				})
				.catch((err) => {
					this.loading = false;
					console.log(err);
					// Notie.error("Failed to load public taskbank config", err);
				});
		},
		loadMore() {
			let left = 0;
			if (this.assessments.length - this.loaded > 4) {
				left = 4;
			} else {
				left = this.assessments.length - this.loaded;
			}

			for (let index = this.loaded; index < this.loaded + left; index++) {
				this.selectedAssessments.push(this.assessments[index]);
			}
			this.loaded = this.loaded + 4;
		},
		goToLogin() {
			Router.push({ path: `/public/login/${this.refID}` });
		},
		goToRegister() {
			Router.push({ path: `/public/register/${this.refID}` });
		},
		goToProfile() {
			Router.push({ path: `/public/profile/${this.refID}` });
		},
		Logout() {
			let token = store.get(this, "bank_token");
			TaskBankService.bankLogout(token)
				.then((resp) => {
					this.bankUser = null;
					store.set(this, "bank_token", null);
					Router.push({ path: `/public/tasks/${this.refID}` });
				})
				.catch((err) => {
					Router.push({ path: `/public/tasks/${this.refID}` });

					Notie.error(err);
				});
		},
		filterAssesments() {
			let filteredAssesments = this.assessments;

			let filteredAssesments1 = [];
			if (this.searchObject.grades && this.searchObject.grades.length > 0) {
				for (const assessment of filteredAssesments) {
					let matched = false;

					for (const matchGrade of this.searchObject.grades) {
						let index = assessment.grades.findIndex((x) => x.id === matchGrade.id);
						if (index != -1) {
							matched = true;
						}
					}

					if (matched) {
						filteredAssesments1.push(assessment);
					}
				}
			} else {
				filteredAssesments1 = this.assessments;
			}

			let filteredAssesments2 = [];
			if (this.searchObject.standard && this.searchObject.standards.length > 0) {
				for (const assessment of filteredAssesments1) {
					let matched = false;

					for (const matchStandard of this.searchObject.standards) {
						let index = assessment.standards.findIndex((x) => x === matchStandard.name);
						if (index != -1) {
							matched = true;
						}
					}

					if (matched) {
						filteredAssesments2.push(assessment);
					}
				}
			} else {
				filteredAssesments2 = filteredAssesments1;
			}

			let filteredAssesments3 = [];
			if (this.searchObject.contentAreas && this.searchObject.contentAreas.length > 0) {
				for (const assessment of filteredAssesments2) {
					let matched = false;

					for (const matchAsmt of this.searchObject.contentAreas) {
						let index = assessment.secondary_content_area_id.findIndex((x) => x === matchAsmt.id);
						if (index != -1) {
							matched = true;
						}
						if (assessment.content_area_id == matchAsmt.id) {
							matched = true;
						}
					}

					if (matched) {
						filteredAssesments3.push(assessment);
					}
				}
			} else {
				filteredAssesments3 = filteredAssesments2;
			}
			this.asmtLength = filteredAssesments3.length;

			let filteredAssesments4 = [];
			if (this.searchObject.districts && this.searchObject.districts.length > 0) {
				for (const assessment of filteredAssesments3) {
					let matched = false;

					for (const matchDistrict of this.searchObject.districts) {
						if (assessment.district_id == matchDistrict.id) {
							matched = true;
						}
					}

					if (matched) {
						filteredAssesments4.push(assessment);
					}
				}
			} else {
				filteredAssesments4 = filteredAssesments3;
			}
			this.asmtLength = filteredAssesments4.length;

			this.selectedAssessments = filteredAssesments4;
		},
		loadConfigData() {
			BB.props({
				essentialSkills: ConfigService.getPublicEssentialSkills(this.refID),
				grades: ConfigService.getPublicGrades(this.refID),
				standards: ConfigService.getPublicStandards(this.refID),
				contentAreas: ConfigService.getPublicContentAreas(this.refID),
				districts: DistrictService.getPublicDistricts(this.refID),
			})
				.then((resps) => {
					this.essentialSkills = resps.essentialSkills.data;

					this.grades = resps.grades.data;
					this.selectedGrades = store.get(this, "public.grades");
					this.standards = resps.standards.data;
					this.selectedStandards = store.get(this, "public.standards");

					this.contentAreas = resps.contentAreas.data;
					this.selectedContentAreas = store.get(this, "public.contentAreas");

					this.districts = resps.districts.data.districts;
					this.selectedDistricts = store.get(this, "public.districts");

					this.loading = false;
				})
				.catch((err) => {
					console.log(err);
					Notie.error("Failed to load public data", err);
				});
		},
		download() {
			const doc = new jsPDF();
			const contentHtml = this.$refs.content.innerHTML;
			doc.fromHTML(contentHtml, 15, 15, {
				width: 170,
			});
			doc.save("sample.pdf");
		},

		checkUser() {
			// check cookies
			let cookie = store.get(this, "bank_token");
			console.log("token found ", cookie);
			if (cookie) {
				TaskBankService.getBankUser(cookie.id)
					.then((resp) => {
						this.bankUser = resp.data;
						console.log(resp);
					})
					.catch((err) => {
						Notie.error(err);
					});
			}
		},
		printFacture(asmtID) {
			var pdf = new jsPDF();
			var element = document.getElementById(asmtID);
			var width = element.style.width;
			var height = element.style.height;
			html2canvas(element).then((canvas) => {
				var image = canvas.toDataURL("image/png");
				pdf.addImage(image, "JPEG", 15, 40, width, height);
				pdf.save("facture.pdf");
			});
		},
	},

	Initial(index) {
		return this.assessment.test_responses[index];
	},
	watchChanges() {
		if (this.unwatch) {
			this.unwatch();
		}
		this.unwatch = this.$watch(
			"assessment",
			(newc, old) => {
				this.dirty = true;
			},
			{ deep: true }
		);
	},

	canSave() {
		return this.dirty;
	},
};
</script>



// WEBPACK FOOTER //
// src/vues/Scan/PublicAssessments.vue